module.exports = __webpack_public_path__ + "static/media/fly0211.92066bbd.webp";